const getDaysInMonth = (year: number, month: number) => new Date(year, month, 0).getDate();

const addMonths = (input: Date, months: number) => {
    const date = new Date(input);
    date.setUTCHours(0, 0, 0, 0);
    date.setDate(1);
    date.setMonth(date.getMonth() + months);
    date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth() + 1)));
    return date;
};


/**
 * Calculates the start date relative to a given end date based on a specified interval.
 * This function supports various intervals, including days, weeks, months, and years.
 * It adjusts the start date accordingly, ensuring that the resulting date is valid.
 * For example, if the interval is '1m' and the end date is February 28th, the start date will be January 28th.
 * If the end date is February 29th, the start date will be January 29th, unless the previous year is not a leap year,
 * in which case the start date will be January 28th.
 *
 * @param {Date} endDate - The end date from which to calculate the start date.
 * @param {string} interval - The interval to calculate the start date from, e.g. '1d', '1w', '2w', '1m', '3m', '6m', '1y', '2y', '3y'.
 * @returns {Date} The calculated start date.
 */
export function intervalStartDateRelativeTo(endDate: Date, interval: string): Date {
    let startDate = null;

    const intervalParts = interval.match(/(\d+)([dwmy])/);
    if (intervalParts) {
        const amount = Number.parseInt(intervalParts[1]);
        const unit = intervalParts[2];
        switch(unit) {
            case 'd':
                startDate = new Date(endDate.getTime() - amount*24*3600*1000);
                break;
            case 'w':
                startDate = new Date(endDate.getTime() - amount*7*24*3600*1000);
                break;
            case 'm':
                startDate = addMonths(endDate, -amount);
                break;
            case 'y':
                startDate = addMonths(endDate, -amount * 12);
                break;
            default:
                startDate = new Date(2000,0,1);
        }
    } else {
        startDate = new Date(2000,0,1);
    }

    // Set start date to 00:00:00 UTC
    startDate.setUTCHours(0, 0, 0, 0);

    return startDate;
}
